<template>
  <div id="form">
    <div id="steps" class="col-12" v-if="$route.params.step != 'about'">
      <div class="step" v-if="$route.params.step == 'you'">
        <h3>Promoção TASK por 1 ano!</h3>

        <p class="top-message">
          Participe do sorteio que irá presentear sua equipe com
          <b>3 contas do Task por 1 ano</b>! Para participar,
          <b
            >siga o nosso instagram
            <a href="https://www.instagram.com/tarstecnologia" target="_blank"
              >@tarstecnologia</a
            >
            e preencha o formulário abaixo.</b
          >
        </p>

        <text-field
          label="@seu_instagram"
          type="text"
          v-model="instagram"
          :validations="$v.instagram"          
        ></text-field>
        <p>
          Informe o seu <b>instagram</b> para poder ser sorteado.
        </p>

        <text-field
          label="Nome completo"
          type="text"
          v-model="name"
          :validations="$v.name"
        ></text-field>

        <text-field
          label="Endereço de e-mail"
          type="email"
          v-model="email"
          :validations="$v.email"
        ></text-field>

        <div class="row m-0">
          <v-checkbox v-model="acceptTerms" class="cols-1"></v-checkbox>
          <p class="bottom-message col-11">
            Ao informar seus dados e seguir para a próxima etapa, você
            automaticamente concorda com o
            <b
              ><a href="https://one.tars.com.br/policies/terms" target="_blank"
                >termo de serviço</a
              ></b
            >
            e a
            <b
              ><a
                href="https://one.tars.com.br/policies/privacy"
                target="_blank"
                >política de privacidade</a
              ></b
            >.
          </p>
        </div>
      </div>

      <div v-if="$route.params.step == 'company'" class="step" data-app>
        <p class="top-message">
          Preencha os dados da sua empresa e sua equipe.
          <b>O Task é muito melhor com seu time!</b>
        </p>

        <text-field
          label="Nome da empresa"
          type="text"
          v-model="company"
          :validations="$v.company"
        ></text-field>

        <v-select
          class="v-select-customized"
          :items="companySizeOptions"
          label="Tamanho da equipe"
          item-text="name"
          item-value="id"
          v-model="companySize"
          :validations="$v.companySize"
          :menu-props="{ bottom: true, offsetY: true }"
          dense
        ></v-select>

        <text-field
          label="Seu papel na equipe"
          type="text"
          v-model="role"
          :validations="$v.role"
        ></text-field>

        <text-field
          label="Telefone de contato"
          type="text"
          v-bind:mask="['(##) ####-####', '(##) #####-####']"
          v-model="phone"
          :validations="$v.phone"
        ></text-field>
      </div>

      <div id="bottom-buttons" v-if="!this.$store.state.caller.isLoading">
        <div id="forward-button">
          <button
            v-if="$route.params.step == 'you'"
            class="button forward-button"
            v-on:click="evtNextStep"
            :disabled="!acceptTerms"
          >
            CONTINUAR
          </button>

          <button
            v-if="$route.params.step == 'company'"
            class="button forward-button"
            v-on:click="evtSend"
          >
            PARTICIPAR
          </button>
        </div>

        <div id="back-button" v-if="$route.params.step == 'company'">
          <button v-on:click="evtGoBack" class="button back-button">
            <i class="fas fa-arrow-left"></i>
          </button>
        </div>
      </div>

      <div class="get-ready" v-if="this.$store.state.caller.isLoading">
        <div id="app-loader">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <h3>Aguarde enquanto realizamos sua inscrição</h3>
      </div>
    </div>

    <div v-if="$route.params.step == 'about'" id="steps">
      <v-card color="#24c074" dark
        style="margin-top: 10px">
        <v-card-title class="text-h5">
          Pronto! Você já está participando.
        </v-card-title>

        <v-card-subtitle
          >Compartilhe com membros da sua equipe para aumentar as
          chances!</v-card-subtitle
        >
      </v-card>

      <v-card color="#5f338a" dark
      style="margin-top: 10px">
        <v-card-title class="text-h5">
          O sorteio será realizado no dia 31/12/2021.
        </v-card-title>

        <v-card-subtitle
          >Siga-nos para acompanhar estar por dentro das
          novidades:</v-card-subtitle
        >

        <v-card-actions>
          <v-btn class="mx-2"
            href="https://www.instagram.com/tarstecnologia/" 
            target="_blank"
            icon>
            <v-icon>
              fab fa-instagram-square
            </v-icon>
          </v-btn>
          <v-btn class="mx-2"
            href="https://www.facebook.com/tecnologiatars" 
            target="_blank"
            icon>
            <v-icon 
              color="green darken-2">
              fab fa-facebook-square
            </v-icon>            
          </v-btn>          
          <v-btn class="mx-2"
            href="https://www.linkedin.com/company/tecnologiatars/" 
            target="_blank"
            icon>
            <v-icon>
              fab fa-linkedin
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card color="#5f338a" dark
      style="margin-top: 10px">
        <v-card-title class="text-h5">
          Já quer começar a usar?
        </v-card-title>

        <v-card-subtitle
          >Inscreva-se para o período de avaliação gratuito e acelere a
          competitividade da sua equipe!.</v-card-subtitle
        >

        <v-card-actions>
          <v-btn text @click="evtRedirectToOne">
            Inscreva-se agora
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import TextField from "@/components/TextField.vue";
import { required, email } from "vuelidate/lib/validators";
import { _utils } from "@/lib/utils.js";

const promoSteps = [
  { id: 1, name: "you" },
  { id: 2, name: "company" },
];

const companySizeOptions = [
  { id: "3 a 5", name: "3 à 5" },
  { id: "5 a 15", name: "5 à 15" },
  { id: "15 a 50", name: "15 à 50" },
  { id: "+ 50", name: "mais de 50" },
];

export default {
  name: "Home",
  components: {
    TextField /*,
    SelectField*/,
  },
  data: function() {
    return {
      name: "",
      email: "",
      phone: "",
      company: "",
      companySize: {},
      role: "",
      instagram: "",
      companySizeOptions: companySizeOptions,
      acceptTerms: false,
    };
  },
  methods: {
    evtCheckForm: function(route) {
      var formValid = true;
      var parent = this; // eslint-disable-line
      function touch(fields) {
        fields.forEach((field) => {
          eval("parent.$v." + field + ".$touch()");
          if (eval("parent.$v." + field + ".$error") === true) {
            formValid = false;
          }
        });
      }

      if (route == "you") {
        touch(["name", "email", "instagram"]);
      } else if (route == "company") {
        touch(["company", "companySize", "role", "phone"]);
      }

      return formValid;
    },
    checkEmail: async function() {
      await this.$v.email.$touch();
    },
    evtSend: async function() {
      if (!this.evtCheckForm("company")) return;

      await this.$store.dispatch("promo/sendSubscription", {
        data: this.getForm(),
        setLoading: true,
      });

      this.$router.push("/promo/about");
    },
    getPartialForm: function() {
      return {
        Name: this.name,
        Email: this.email,
        Instagram: this.instagram,
      };
    },
    getForm: function() {
      return {
        Name: this.name,
        Email: this.email,
        Phone: this.phone,
        Company: this.company,
        CompanySize: this.companySize.id,
        Role: this.role,
        Instagram: this.instagram,
      };
    },
    evtNextStep: async function() {
      let currentRoute = promoSteps.filter(
        (x) => x.name == this.$route.params.step
      )[0];

      if (!this.evtCheckForm(currentRoute.name)) return;

      if (currentRoute.name == "you") {
        this.acceptTerms = true;

        await this.$store.dispatch("promo/sendSubscription", {
          data: this.getPartialForm(),
          setLoading: false,
        });
      }

      var nextRoute = promoSteps.filter((x) => x.id == currentRoute.id + 1)[0];

      this.$router.push("/promo/" + nextRoute.name);

      this.evtRouteChanged();
    },
    evtGoBack: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
      this.boolShowButtonNextStep = true;
      this.evtRouteChanged();
    },
    evtRouteChanged: function() {
      _utils.actions.focusOnFirstField(".step");
    },
    evtRedirectToOne: function() {
      this.$router.push("/signup/business/welcome");
    },
  },
  validations: {
    name: { required },
    email: { required, email },
    companySize: { required },
    company: { required },
    phone: { required },
    role: { required },
    instagram: { required },
  },
  beforeCreate: function() {
    if (this.$route.params.step != "you")
       this.$router.replace("/promo/you");
  },
  mounted: function() {
    _utils.actions.focusOnFirstField("#steps");
  },
};
</script>

<style lang="scss">
.text-field-area,
.text-field-holder,
.text-field,
.input-border,
.input-border-animate {
  box-sizing: content-box;
}

#form {
  display: flex;
  margin: 15px;
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  #steps {
    flex: 1;

    .title {
      font-weight: 400;
      font-size: 35px;
      border-bottom: 1px solid #ddd;
    }

    .step {
      margin-top: 20px;

      h3 {
        font-weight: 400;
        font-size: 18px;
      }

      h4 {
        font-weight: 400;
        font-size: 16px;

        a {
          cursor: pointer;
        }

        a:hover {
          color: deepskyblue;
        }
      }

      p {
        font-size: 13px;
        color: #999;
        margin-bottom: 0;
      }

      p.top-message {
        text-align: justify;
      }

      p.bottom-message {
        margin-top: 20px;
        text-align: justify;
      }

      #read-accept {
        margin-top: 20px;
        height: 30px;

        #message {
          font-size: 13px;
          line-height: 20px;

          .terms {
            color: #108f65;
            font-weight: 500;
          }
        }
      }
    }

    #bottom-buttons {
      display: flex;
      flex-direction: row-reverse;
      margin-top: 40px;

      #back-button {
        flex: 1;

        button {
          border-radius: 20px;
          padding: 8px 10px;
          background-color: #fff;
          border: 2px solid #fff;
          font-size: 16px;
          transition: background-color 0.2s;
          cursor: pointer;
          text-align: center;
          outline: none;
          color: #25b686;
        }

        button:hover {
          background-color: #eee;
        }
      }

      #forward-button {
        flex: 4;
        text-align: right;
        margin-right: 15px;

        button {
          border-radius: 3px;
          background-color: #25b686;
          color: #fff;
          padding: 10px 30px;
          border: none;
          font-size: 13px;
          transition: background-color 0.2s;
          cursor: pointer;
          text-align: center;
          outline: none;
        }

        button:hover,
        button:focus {
          background-color: #108f65;
        }

        button:disabled {
          background-color: #ccc;
          cursor: not-allowed;
        }
      }
    }

    .get-ready {
      text-align: center;

      h3 {
        font-weight: 300;
        text-align: center;
        font-size: 16px;
      }

      #app-loader {
        font-size: 0.875em;
        color: white;
        background-color: transparent;
        padding: 5px;
        border-radius: 4px;
        width: 100%;
      }
      .lds-ring {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
      }
      .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid #24c074;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #24c074 transparent transparent transparent;
      }
      .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
      }
      .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
      }
      .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
      }
      @keyframes lds-ring {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }
}

.v-select-customized {
  margin-top: 30px !important;
  margin-bottom: -20px !important;
  width: 97%;
}

.v-text-field .v-label--active {
  max-width: 133%;
  -webkit-transform: translateY(-18px) scale(0.75);
  transform: translateY(-23px) scale(0.75) translateX(-23px) !important;
  pointer-events: auto;
}
</style>
